const listTemplate2 = (editor) => {

    editor.BlockManager.add('listTemplate2', {
        category: `List Items`,
        label: `
                    <svg  width="1.4vw" height="1.4vw" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path class="gjs-block-svg-path" fill-rule="evenodd" d="M2 2.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H2zM3 3H2v1h1V3z"/>
                    <path class="gjs-block-svg-path" d="M5 3.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM5.5 7a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9zm0 4a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9z"/>
                    <path class="gjs-block-svg-path" fill-rule="evenodd" d="M1.5 7a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5V7zM2 7h1v1H2V7zm0 3.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H2zm1 .5H2v1h1v-1z"/>
                    </svg>
                    <div class='gjs-fontFamily gjs-block-label'>Users List</div>
                  `,
        attributes: {},
        content: `
        <div class="container p-3">
            <div>
                <button type="button" classtype='text-green' class="btn fs-2 fw-normal m-3 text-green">
                    <i class="bi bi-chevron-left"></i>List of Patients
                </button>
            </div>
            <div class="input-group col-8 col-sm-4 ms-auto mb-3 w-auto">
                <span classtype='searchbar-button' class="input-group-text searchbar-button w-auto border-0"
                    ><i class="bi bi-search text-white"></i
                ></span>
                <input
                    pseudotype='searchbar'
                    statetype='searchbar'
                    classtype='searchbar'
                    type="text"
                    class="form-control border-0 text-white searchbar"
                    placeholder="Search for a Patient"
                    aria-label="Search"
                    aria-describedby="search-icon"
                />
            </div>
            <div class="ms-auto col-4 d-flex justify-content-end">
                <button
                    classtype='list-button'
                    class="btn pointer my-4 px-4 py-3 ms-auto list-button border-0"
                >
                    <i class="bi bi-plus"></i> Add A New Patient
                </button>
            </div>

            <div class="container mb-3">
                <div class="row col-12 g-3 justify-content-center align-items-center" dataItems="getAllCards">
                    <div class="col-12 col-xl-5 mr-xl-5 mb-4 mb-xl-0"  dataitem=true>
                        <div class="row align-items-center">
                            <div classtype='user-img' class="col-auto user-img ml-5 ml-sm-0">
                                <img
                                    dataCardImage=true
                                    src="https://i.ibb.co/S5wJS5j/d18c1521c859.png"
                                    class="rounded-circle d-none d-sm-block shadow-lg"
                                    alt="User Image"
                                    width="120"
                                    height="120"
                                />
                            </div>
                            <div classtype='patientcard-text' class="col d-flex flex-row patientcard-text text-center">
                                <div class="rounded p-3 col ">
                                    <h5 class="card-title" dataCardTitle=true>holouser01</h5>
                                    <p classtype='text-green' class="card-text text-green" dataCardDescription=true>Last Session: 5 days ago</p>
                                </div>
                                <button class="btn btn-link p-0" dataCardButton=true>
                                    <i classtype='text-green' class="bi bi-three-dots-vertical fs-1 text-green"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-xl-5 mb-4 mb-xl-0" dataitem=true>
                        <div class="row align-items-center">
                            <div classtype='user-img' class="col-auto user-img ml-5 ml-sm-0">
                                <img
                                    dataCardImage=true
                                    src="https://i.ibb.co/S5wJS5j/d18c1521c859.png"
                                    class="rounded-circle d-none d-sm-block shadow-lg"
                                    alt="User Image"
                                    width="120"
                                    height="120"
                                />
                            </div>
                            <div classtype='patientcard-text' class="col d-flex flex-row patientcard-text text-center">
                                <div class="rounded p-3 col">
                                    <h5 class="card-title" dataCardTitle=true>holouser02</h5>
                                    <p classtype='text-green' class="card-text text-green" dataCardDescription=true>Last Session: 5 days ago</p>
                                </div>
                                <button classtype='text-green' class="btn btn-link text-green p-0" dataCardButton=true>
                                    <i classtype='text-green' class="bi bi-three-dots-vertical fs-1 text-green"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-xl-5 mr-xl-5 mb-4 mb-xl-0"  dataitem=true>
                        <div class="row align-items-center">
                            <div classtype='user-img' class="col-auto user-img ml-5 ml-sm-0">
                                <img
                                    dataCardImage=true
                                    src="https://i.ibb.co/S5wJS5j/d18c1521c859.png"
                                    class="rounded-circle d-none d-sm-block shadow-lg"
                                    alt="User Image"
                                    width="120"
                                    height="120"
                                />
                            </div>
                            <div classtype='patientcard-text' class="col d-flex flex-row patientcard-text text-center">
                                <div class="rounded p-3 col ">
                                    <h5 class="card-title" dataCardTitle=true>holouser03</h5>
                                    <p classtype='text-green' class="card-text text-green" dataCardDescription=true>Last Session: 5 days ago</p>
                                </div>
                                <button class="btn btn-link p-0" dataCardButton=true>
                                    <i classtype='text-green' class="bi bi-three-dots-vertical fs-1 text-green"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-xl-5 mb-4 mb-xl-0" dataitem=true>
                        <div class="row align-items-center">
                            <div classtype='user-img' class="col-auto user-img ml-5 ml-sm-0">
                                <img
                                    dataCardImage=true
                                    src="https://i.ibb.co/S5wJS5j/d18c1521c859.png"
                                    class="rounded-circle d-none d-sm-block shadow-lg"
                                    alt="User Image"
                                    width="120"
                                    height="120"
                                />
                            </div>
                            <div classtype='patientcard-text' class="col d-flex flex-row patientcard-text text-center">
                                <div class="rounded p-3 col">
                                    <h5 class="card-title" dataCardTitle=true>holouser04</h5>
                                    <p classtype='text-green' class="card-text text-green" dataCardDescription=true>Last Session: 5 days ago</p>
                                </div>
                                <button classtype='text-green' class="btn btn-link text-green p-0" dataCardButton=true>
                                    <i classtype='text-green' class="bi bi-three-dots-vertical fs-1 text-green"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-xl-5 mr-xl-5 mb-4 mb-xl-0"  dataitem=true>
                        <div class="row align-items-center">
                            <div classtype='user-img' class="col-auto user-img ml-5 ml-sm-0">
                                <img
                                    dataCardImage=true
                                    src="https://i.ibb.co/S5wJS5j/d18c1521c859.png"
                                    class="rounded-circle d-none d-sm-block shadow-lg"
                                    alt="User Image"
                                    width="120"
                                    height="120"
                                />
                            </div>
                            <div classtype='patientcard-text' class="col d-flex flex-row patientcard-text text-center">
                                <div class="rounded p-3 col ">
                                    <h5 class="card-title" dataCardTitle=true>holouser05</h5>
                                    <p classtype='text-green' class="card-text text-green" dataCardDescription=true>Last Session: 5 days ago</p>
                                </div>
                                <button class="btn btn-link p-0" dataCardButton=true>
                                    <i classtype='text-green' class="bi bi-three-dots-vertical fs-1 text-green"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-xl-5 mb-4 mb-xl-0" dataitem=true>
                        <div class="row align-items-center">
                            <div classtype='user-img' class="col-auto user-img ml-5 ml-sm-0">
                                <img
                                    dataCardImage=true
                                    src="https://i.ibb.co/S5wJS5j/d18c1521c859.png"
                                    class="rounded-circle d-none d-sm-block shadow-lg"
                                    alt="User Image"
                                    width="120"
                                    height="120"
                                />
                            </div>
                            <div classtype='patientcard-text' class="col d-flex flex-row patientcard-text text-center">
                                <div class="rounded p-3 col">
                                    <h5 class="card-title" dataCardTitle=true>holouser06</h5>
                                    <p classtype='text-green' class="card-text text-green" dataCardDescription=true>Last Session: 5 days ago</p>
                                </div>
                                <button classtype='text-green' class="btn btn-link text-green p-0" dataCardButton=true>
                                    <i classtype='text-green' class="bi bi-three-dots-vertical fs-1 text-green"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-xl-5 mr-xl-5 mb-4 mb-xl-0"  dataitem=true>
                        <div class="row align-items-center">
                            <div classtype='user-img' class="col-auto user-img ml-5 ml-sm-0">
                                <img
                                    dataCardImage=true
                                    src="https://i.ibb.co/S5wJS5j/d18c1521c859.png"
                                    class="rounded-circle d-none d-sm-block shadow-lg"
                                    alt="User Image"
                                    width="120"
                                    height="120"
                                />
                            </div>
                            <div classtype='patientcard-text' class="col d-flex flex-row patientcard-text text-center">
                                <div class="rounded p-3 col ">
                                    <h5 class="card-title" dataCardTitle=true>holouser07</h5>
                                    <p classtype='text-green' class="card-text text-green" dataCardDescription=true>Last Session: 5 days ago</p>
                                </div>
                                <button class="btn btn-link p-0" dataCardButton=true>
                                    <i classtype='text-green' class="bi bi-three-dots-vertical fs-1 text-green"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-xl-5 mb-4 mb-xl-0" dataitem=true>
                        <div class="row align-items-center">
                            <div classtype='user-img' class="col-auto user-img ml-5 ml-sm-0">
                                <img
                                    dataCardImage=true
                                    src="https://i.ibb.co/S5wJS5j/d18c1521c859.png"
                                    class="rounded-circle d-none d-sm-block shadow-lg"
                                    alt="User Image"
                                    width="120"
                                    height="120"
                                />
                            </div>
                            <div classtype='patientcard-text' class="col d-flex flex-row patientcard-text text-center">
                                <div class="rounded p-3 col">
                                    <h5 class="card-title" dataCardTitle=true>holouser08</h5>
                                    <p classtype='text-green' class="card-text text-green" dataCardDescription=true>Last Session: 5 days ago</p>
                                </div>
                                <button classtype='text-green' class="btn btn-link text-green p-0" dataCardButton=true>
                                    <i classtype='text-green' class="bi bi-three-dots-vertical fs-1 text-green"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-xl-5 mr-xl-5 mb-4 mb-xl-0"  dataitem=true>
                        <div class="row align-items-center">
                            <div classtype='user-img' class="col-auto user-img ml-5 ml-sm-0">
                                <img
                                    dataCardImage=true
                                    src="https://i.ibb.co/S5wJS5j/d18c1521c859.png"
                                    class="rounded-circle d-none d-sm-block shadow-lg"
                                    alt="User Image"
                                    width="120"
                                    height="120"
                                />
                            </div>
                            <div classtype='patientcard-text' class="col d-flex flex-row patientcard-text text-center">
                                <div class="rounded p-3 col ">
                                    <h5 class="card-title" dataCardTitle=true>holouser09</h5>
                                    <p classtype='text-green' class="card-text text-green" dataCardDescription=true>Last Session: 5 days ago</p>
                                </div>
                                <button class="btn btn-link p-0" dataCardButton=true>
                                    <i classtype='text-green' class="bi bi-three-dots-vertical fs-1 text-green"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-xl-5 mb-4 mb-xl-0" dataitem=true>
                        <div class="row align-items-center">
                            <div classtype='user-img' class="col-auto user-img ml-5 ml-sm-0">
                                <img
                                    dataCardImage=true
                                    src="https://i.ibb.co/S5wJS5j/d18c1521c859.png"
                                    class="rounded-circle d-none d-sm-block shadow-lg"
                                    alt="User Image"
                                    width="120"
                                    height="120"
                                />
                            </div>
                            <div classtype='patientcard-text' class="col d-flex flex-row patientcard-text text-center">
                                <div class="rounded p-3 col">
                                    <h5 class="card-title" dataCardTitle=true>holouser10</h5>
                                    <p classtype='text-green' class="card-text text-green" dataCardDescription=true>Last Session: 5 days ago</p>
                                </div>
                                <button classtype='text-green' class="btn btn-link text-green p-0" dataCardButton=true>
                                    <i classtype='text-green' class="bi bi-three-dots-vertical fs-1 text-green"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-xl-5 mr-xl-5 mb-4 mb-xl-0"  dataitem=true>
                        <div class="row align-items-center">
                            <div classtype='user-img' class="col-auto user-img ml-5 ml-sm-0">
                                <img
                                    dataCardImage=true
                                    src="https://i.ibb.co/S5wJS5j/d18c1521c859.png"
                                    class="rounded-circle d-none d-sm-block shadow-lg"
                                    alt="User Image"
                                    width="120"
                                    height="120"
                                />
                            </div>
                            <div classtype='patientcard-text' class="col d-flex flex-row patientcard-text text-center">
                                <div class="rounded p-3 col ">
                                    <h5 class="card-title" dataCardTitle=true>holouser11</h5>
                                    <p classtype='text-green' class="card-text text-green" dataCardDescription=true>Last Session: 5 days ago</p>
                                </div>
                                <button class="btn btn-link p-0" dataCardButton=true>
                                    <i classtype='text-green' class="bi bi-three-dots-vertical fs-1 text-green"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-xl-5 mb-4 mb-xl-0" dataitem=true>
                        <div class="row align-items-center">
                            <div classtype='user-img' class="col-auto user-img ml-5 ml-sm-0">
                                <img
                                    dataCardImage=true
                                    src="https://i.ibb.co/S5wJS5j/d18c1521c859.png"
                                    class="rounded-circle d-none d-sm-block shadow-lg"
                                    alt="User Image"
                                    width="120"
                                    height="120"
                                />
                            </div>
                            <div classtype='patientcard-text' class="col d-flex flex-row patientcard-text text-center">
                                <div class="rounded p-3 col">
                                    <h5 class="card-title" dataCardTitle=true>holouser12</h5>
                                    <p classtype='text-green' class="card-text text-green" dataCardDescription=true>Last Session: 5 days ago</p>
                                </div>
                                <button classtype='text-green' class="btn btn-link text-green p-0" dataCardButton=true>
                                    <i classtype='text-green' class="bi bi-three-dots-vertical fs-1 text-green"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-xl-5 mr-xl-5 mb-4 mb-xl-0"  dataitem=true>
                        <div class="row align-items-center">
                            <div classtype='user-img' class="col-auto user-img ml-5 ml-sm-0">
                                <img
                                    dataCardImage=true
                                    src="https://i.ibb.co/S5wJS5j/d18c1521c859.png"
                                    class="rounded-circle d-none d-sm-block shadow-lg"
                                    alt="User Image"
                                    width="120"
                                    height="120"
                                />
                            </div>
                            <div classtype='patientcard-text' class="col d-flex flex-row patientcard-text text-center">
                                <div class="rounded p-3 col ">
                                    <h5 class="card-title" dataCardTitle=true>holouser13</h5>
                                    <p classtype='text-green' class="card-text text-green" dataCardDescription=true>Last Session: 5 days ago</p>
                                </div>
                                <button class="btn btn-link p-0" dataCardButton=true>
                                    <i classtype='text-green' class="bi bi-three-dots-vertical fs-1 text-green"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-xl-5 mb-4 mb-xl-0" dataitem=true>
                        <div class="row align-items-center">
                            <div classtype='user-img' class="col-auto user-img ml-5 ml-sm-0 ">
                                <img
                                    dataCardImage=true
                                    src="https://i.ibb.co/S5wJS5j/d18c1521c859.png"
                                    class="rounded-circle d-none d-sm-block shadow-lg"
                                    alt="User Image"
                                    width="120"
                                    height="120"
                                />
                            </div>
                            <div classtype='patientcard-text' class="col d-flex flex-row patientcard-text text-center">
                                <div class="rounded p-3 col">
                                    <h5 class="card-title" dataCardTitle=true>holouser14</h5>
                                    <p classtype='text-green' class="card-text text-green" dataCardDescription=true>Last Session: 5 days ago</p>
                                </div>
                                <button classtype='text-green' class="btn btn-link text-green p-0" dataCardButton=true>
                                    <i classtype='text-green' class="bi bi-three-dots-vertical fs-1 text-green"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        `
    })
}

export default listTemplate2;